var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSapPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40006191_169167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM3.68848 19.9893H8.08789V15.5898H3.68848V19.9893ZM9.55469 19.9893H13.9551V15.5898H9.55469V19.9893ZM15.4209 19.9893H19.8213V15.5898H15.4209V19.9893ZM6.62109 14.123H11.0215V9.72266H6.62109V14.123ZM12.4883 14.123H16.8877V9.72266H12.4883V14.123ZM2.63184 6.78906C2.45096 6.87464 2.31153 7.02936 2.24414 7.21777C2.17692 7.40599 2.18706 7.61325 2.27246 7.79395C2.35797 7.97468 2.51199 8.11419 2.7002 8.18164C2.88861 8.24903 3.09647 8.2389 3.27734 8.15332L11.7549 3.85645L20.2324 8.18262C20.3329 8.23125 20.443 8.25632 20.5547 8.25586C20.7481 8.29579 20.9496 8.25784 21.1152 8.15039C21.2808 8.04294 21.397 7.87439 21.4395 7.68164C21.4818 7.48888 21.447 7.28708 21.3418 7.12012C21.2365 6.95315 21.0692 6.83397 20.877 6.78906L11.7549 2.27246L2.63184 6.78906Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40006191_169167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapPlatform);
export default __webpack_public_path__ + "static/media/SAP_Platform.4853e75cac48a3774b40d893a0be0e39.svg";
export { ForwardRef as ReactComponent };